(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('BridgeConfirmController', BridgeConfirmController);

    BridgeConfirmController.$inject = ['$scope', '$uibModalInstance', 'BridgeService', 'dataAction', 'bridgeData'];

    function BridgeConfirmController($scope, $uibModalInstance, BridgeService, dataAction, bridgeData) {
        var vm = this;
        vm.requestRunning = false;
        vm.name = '';

        if (dataAction) {
            vm.action = dataAction.action;
            vm.name = bridgeData.name;

            vm.close = function () {
                if (!vm.requestRunning) {
                    $uibModalInstance.dismiss('cancel');
                }
            }

            vm.confirmAction = function () {
                if (dataAction.methodDependency) {
                    dataAction.methodDependency(bridgeData).then(function (result) {
                        if (result) {
                            vm.requestRunning = true;
                            var data = dataAction.action == 'update' ? bridgeData : bridgeData.id;
                            BridgeService[dataAction.methodService](data).then(success).catch(error);
                        }
                    });
                } else {
                    vm.requestRunning = true;
                    var data = dataAction.action == 'update' ? bridgeData : bridgeData.id;
                    BridgeService[dataAction.methodService](data).then(success).catch(error);
                }
            }
        }

        function success(data) {
            vm.requestRunning = false;

            if (!dataAction.noSuccessMessage) {
                BridgeService.successModalConstructor(vm.action);
            }

            if (dataAction.methodExtra) {
                var returnData = dataAction.action == 'update' ? data : bridgeData;
                dataAction.methodExtra(returnData);
            }

            if (dataAction.closeOnSuccess) {
                vm.close();
            }
        }

        function error(response) {
            vm.requestRunning = false;
            BridgeService.errorModalConstructor(response, vm.action);
        }

    }
})();
